import React from 'react';
import { Sun, Moon } from 'lucide-react';

/**
 * Sun/Moon toggle for public pages. Animated, accessible, theme-token aware.
 */
export const ThemeToggle = ({ theme, onToggle, className = '', testid = 'public-theme-toggle' }) => {
  const isDark = theme === 'dark';
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-pressed={isDark}
      title={isDark ? 'Light mode' : 'Dark mode'}
      data-testid={testid}
      className={`relative inline-flex h-9 w-9 items-center justify-center rounded-full border border-border bg-card/70 text-foreground/80 backdrop-blur transition-colors hover:text-foreground hover:bg-card focus:outline-none focus-visible:ring-2 focus-visible:ring-ring ${className}`}
    >
      <Sun
        className={`h-[18px] w-[18px] absolute transition-all duration-200 ${isDark ? 'opacity-0 -rotate-90 scale-50' : 'opacity-100 rotate-0 scale-100'}`}
      />
      <Moon
        className={`h-[18px] w-[18px] absolute transition-all duration-200 ${isDark ? 'opacity-100 rotate-0 scale-100' : 'opacity-0 rotate-90 scale-50'}`}
      />
    </button>
  );
};
